import React, { Component, Fragment } from 'react';
import { withAuthorization } from '../Session';
import { Link, withRouter } from 'react-router-dom';
import { compose } from 'recompose';

import { withFirebase } from '../Firebase';
import * as ROUTES from '../../constants/routes';

import ReactPlayer from 'react-player';

import { Grid } from '@material-ui/core';

import { HACKATION_ROLES } from '../../constants/registration';

import '../Homepage/style.css'

class DashboardPageBase extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fname: '', lname: '',
      country: '', timezone: '', hackathon_role: '',
      team_name: '', team_challenge: '', isloading: false
    };
  }

  componentDidMount() {
    let uid = this.props.firebase.auth.currentUser.uid;
    this.props.firebase.user(uid).on("value", snapshot => {
      const userObject = snapshot.val();
      if (userObject) {
        let { fname, lname, country, timezone, hackathon_role, team, competitor, mentor } = userObject;
        if (team) { //load team data if available
          this.setState({ fname, lname, country, timezone, hackathon_role, competitor, mentor, team_name: team.team_name, team_challenge: team.team_challenge });
        } else {
          this.setState({ fname, lname, country, timezone, hackathon_role, competitor, mentor, });
        }
      }
    }, function (errorObject) {
      console.log("The read failed: " + errorObject.code);
    });

  }

  componentWillUnmount() {
    if (this.props.firebase.auth.currentUser && this.props.firebase.auth.currentUser.uid) {
      //console.log("DASHBOARD UNMOUNT");
      this.props.firebase.user(this.props.firebase.auth.currentUser.uid).off();
    }
  }

  onChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };
  onSelectChange = (selectedOption, action) => {
    this.setState({ [action.name]: selectedOption });
  }

  onTeamWidgeSubmit = event => {
    const { team_name, team_challenge } = this.state;
    let desc = { team: { team_name, team_challenge } };
    //update to database
    let uid = this.props.firebase.auth.currentUser.uid
    this.props.firebase.user(uid).update(desc);

    event.preventDefault();

    this.setState({ isloading: true })
  }
  onRegistrationWidgetClick = event => {
    this.props.history.push(ROUTES.REG_HOME);
  }

  getRegistrationSection(isRegistered = false) {
    if (isRegistered) {
      return (
        <Fragment>
          <Grid item>
            STEP 1: You've Registered. Update your details for the #DigitalDefence Hack. This will help us better match you with teams and mentors.
          </Grid>
          <Grid item className="fullwidth">
            <Link to={ROUTES.REG_HOME} className="button" >Update Registration</Link>
          </Grid>  
        </Fragment>
      );
    } else {
      return (
        <Fragment>
          <Grid item>
            STEP 1: You are not Registered. Register for the #DigitalDefence Hack. Get a chance to win over $15,000 worth of prizes and get seen by the biggest names in tech.
          </Grid>
          <Grid item className="fullwidth">
          <Link to={ROUTES.REG_HOME} className="button" >Register Here</Link>
          </Grid>  
        </Fragment>
      );
    }
  }
  getWelcomeText(isRegistered = false, fname) {

    return (
      <div>
        <p>Welcome {(fname?fname+" ":"")}to Hackmakers! You have officially made an account on our hackerspace.</p>
        <p>Thank you for taking the extraordinary first step in helping innovate new solutions to bolster APAC’s cyber security capabilities.
          All registered accounts will receive welcome email onto our Hackerspace and Slack channel in the next 12 hours.</p>
        <br />

        <Grid container spacing={2}>
            <Grid item sm={8} xs={12} className="splash-video">
              <ReactPlayer url="https://www.youtube.com/watch?v=PUFI6Wd4PVA" controls={true} width="100%" height="100%" />
            </Grid>
            <Grid item sm={4} xs={12} container>
              {this.getRegistrationSection(isRegistered)}
              <Grid item>
                STEP 2: Check out announcement summaries, view exclusive resources and check off key actions for the hackathon.
              </Grid>
              <Grid item className="fullwidth">
                <Link type="button" to={ROUTES.USER_DASHBOARD} className="button">Access the HackerSpace</Link>
              </Grid>
              <Grid item>
                STEP 3: Join the Slack channel, introduce yourself and meet other innovative hackers and mentors making a difference.
              </Grid>
              <Grid item className="fullwidth">
                <a href="//digitaldefencehack.slack.com/" target="_blank" rel="noopener noreferrer" className="button">Join the Slack Channel</a>
              </Grid>
            </Grid>
        </Grid>

      </div>
    );

  }


  isRegistered(hackathon_role, competitor, mentor) {
    let _registered = false;
    if (hackathon_role) {
      let _role = hackathon_role.value;
      switch (_role) {
        case HACKATION_ROLES.competitor:
          if (competitor && competitor.timezone && competitor.pref_role && competitor.team_status)
            _registered = true;
          break;
        case HACKATION_ROLES.mentor:
          if (mentor && mentor.hackathon_experience)
            _registered = true;
          break;
        default:
        //not registered
      }
    }
    return _registered;
  }


  render() {
    const { hackathon_role, competitor, mentor, fname } = this.state;

    let _isRegistered = this.isRegistered(hackathon_role, competitor, mentor);

    return (
      <div id="page-dashboard" className="dashboard-page page">
        <div id="loading-panel"><div className="loader"></div></div>
        <div className="bound-box">
          <h1>#DigitalDefence Hack 2020</h1>
          {this.getWelcomeText(_isRegistered, fname)}
        </div>
      </div>
    );
  }
}




const condition = authUser => !!authUser;


const DashboardPage = compose(
  withRouter,
  withFirebase,
)(DashboardPageBase);

export default withAuthorization(condition)(DashboardPage);